const IF = require( "infrontjs" );

export class States extends IF.States
{
    constructor( appInstance )
    {
        super( appInstance );
    }

    async switchTo( newState )
    {
        await super.switchTo( newState );
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
